import { NormalizedDisclosureRIG, NormalizedTopicRIG } from "~/types/docs.types";

// ✅ Initial states
export const initialState: RIGState = {
    disclosureGuides: [],
    topicGuides: [],
};

export enum RIGActions {
    SET_DISCLOSURE_RIGS = "SET_DISCLOSURE_RIGS",
    SET_TOPIC_RIGS = "SET_TOPIC_RIGS",
}

// State type defns
export type RIGState = {
    /** List of normalized Reader Intelligence Disclosure Guides `NormalizedRIG[]` */
    disclosureGuides: NormalizedDisclosureRIG[];
    /** List of Reader Intelligence Topic Guides categorized by disclosure */
    topicGuides: NormalizedTopicRIG[];
};

// Action type defn
export type RIGAction =
    | {
          type: RIGActions.SET_DISCLOSURE_RIGS;
          payload: NormalizedDisclosureRIG[];
      }
    | {
          type: RIGActions.SET_TOPIC_RIGS;
          payload: NormalizedTopicRIG[];
      };

// Store type
export type RIGMethods = "dispatch" | "getDisclosureRIGs" | "getTopicRIGs" | "getSelectedTopicRIGs";

export type RIGStore = RIGState & {
    /**
     * Sets the RIG state using a reducer pattern.
     * @param {RIGAction} action - `RIGAction` action to apply.
     * @example
     * ```
     * const dispatch = useRIGStore((state) => state.dispatch)
     * dispatch({ type: RIGActions.SET_DISCLOSURE_RIGS, payload: NormalizedRIG[] })
     * ```
     */
    dispatch: (action: RIGAction) => void;

    /**
     * Retrieves all available Reader Intelligence Disclosure Guides
     * @example const disclosureGuides = getDisclosureRIGs()
     */
    getDisclosureRIGs: () => NormalizedDisclosureRIG[];

    /**
     * Retrieves all available Reader Intelligence Topic Guides
     * @example const topicGuides = getTopicRIGs()
     */
    getTopicRIGs: () => NormalizedTopicRIG[];

    /**
     * Retrieves all available Reader Intelligence Topic Guides
     * @param selectedTopicIDs - The list of selected search topic IDs by the user
     * @example const topicGuides = getTopicRIGs(topicIds)
     */
    getSelectedTopicRIGs: (selectedTopicIDs: number[]) => NormalizedTopicRIG[];
};
